import baseAPI from '@/http'

const router = 'api/salacusto'

export const SalaCustoAPI = {
  create: (data) => baseAPI.post(router + '/cadastrar-custo', data),
  update: (data) => baseAPI.put(router + '/atualizar-custo', data),
  getbyMunicipio: (id) => baseAPI.get(`${router}/obter-custo-por-municipio/${id}`),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  get: (id) => baseAPI.get(`${router}/${id}`),
  list: () => baseAPI.get(router)

}
